const form= () => {
  function initDropbox(dropbox, fileInput, dropboxText, errorMsg) {

    if (!dropbox || !fileInput || !errorMsg || !dropboxText) {
      console.warn('必要なDOM要素が見つかりません');
      return;
    }

    const allowedExtensions = ['.xlsx', '.xls', '.docx', '.doc', '.pdf', '.zip'];
    const maxSizeMB = 5;
    let isProcessing = false;

    dropbox.addEventListener('click', (e) => {
      e.preventDefault();
      if (!isProcessing) {
        fileInput.click();
      }
    });

    dropbox.addEventListener('dragover', (e) => {
      e.preventDefault();
      dropbox.classList.add('hover');
    });

    dropbox.addEventListener('dragleave', () => {
      dropbox.classList.remove('hover');
    });

    dropbox.addEventListener('drop', (e) => {
      e.preventDefault();
      dropbox.classList.remove('hover');

      if (e.dataTransfer.files.length > 0 && !isProcessing) {
        // validateAndShowFile(e.dataTransfer.files[0]);
        const file = e.dataTransfer.files[0];

        fileInput.files = e.dataTransfer.files;

        validateAndShowFile(file);
      }
    });

    fileInput.addEventListener('change', (e) => {
      if (fileInput.files.length > 0 && !isProcessing) {
        validateAndShowFile(fileInput.files[0]);
      }
    });

    function validateAndShowFile(file) {
      if (isProcessing) return;
      isProcessing = true;
      errorMsg.textContent = '';

      const ext = '.' + file.name.split('.').pop().toLowerCase();
      const isAllowed = allowedExtensions.includes(ext);
      const isSizeOk = file.size <= maxSizeMB * 1024 * 1024;

      if (!isAllowed) {
        errorMsg.textContent = `このファイル形式（${ext}）は許可されていません。`;
        dropboxText.innerHTML = 'ここにファイルをドロップ<br>または';
        resetProcessing();
        return;
      }

      if (!isSizeOk) {
        errorMsg.textContent = `ファイルサイズが大きすぎます（最大 ${maxSizeMB}MB）。`;
        dropboxText.innerHTML = 'ここにファイルをドロップ<br>または';
        resetProcessing();
        return;
      }

      dropboxText.textContent = file.name;
      resetProcessing();
    }

    function resetProcessing() {
      setTimeout(() => {
        isProcessing = false;
      }, 100);
    }
    
  }

  // fileInput01 用
  const dropbox1 = document.getElementById('dropbox01');
  const fileInput01 = document.getElementById('fileInput01');
  const dropboxText1 = document.getElementById('dropbox-text01');
  const errorMsg1 = document.getElementById('errorMsg01');

  if (dropbox1 && fileInput01 && dropboxText1) {
    initDropbox(dropbox1, fileInput01, dropboxText1, errorMsg1);
  }

  // fileInput02 用
  const dropbox2 = document.getElementById('dropbox02');
  const fileInput02 = document.getElementById('fileInput02');
  const dropboxText2 = document.getElementById('dropbox-text02');
  const errorMsg2 = document.getElementById('errorMsg02');

  if (dropbox2 && fileInput02 && dropboxText2) {
    initDropbox(dropbox2, fileInput02, dropboxText2, errorMsg2);
  }
}

export default form;